<template>
    <PersonalSiteInfo ref="personalSiteInfo" :personals="personals"/>
</template>

<script>
import PersonalSiteInfo from '@/components/popup/PersonalSiteInfo'
import {api} from '@/api/index'
export default {
    data() {
        return {
            personals: []
        }
    },
    created() {
        api.postAsync('/system/selectPersonalSiteInfo.do')
            .then(data=> {
                this.personals = data.personals.filter(item=> {
                    if(item.add_type_cd === '90') {
                        return item;
                    }
            
                })
            })
    },
    mounted() {
        $('#popup-personal-cust-site-info').addClass('active');
    },
    components: {PersonalSiteInfo}
    
}
</script>